<template>
  <material-card
    :title="$t('components.plancreationwizard.hour_import_member_identifiers')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="settings"
    style="margin-top:30px"
  >
    <v-card-text>
      <v-form v-model="valid" :disabled="loading || disabled">
        <v-layout row wrap>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <auto-select
              :value.sync="internalPrimaryIdentifier"
              :items="primaryFields"
              :label="$t('components.plancreationwizard.primary')"
              :rules="[$rules.required]"
              item-text="Label"
              :return-object="true"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="internalIncludeContributionAmount"
              :label="
                $t(
                  'components.plan_builder.billingimport.include_contribution_amount'
                )
              "
            />
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="12" class="pt-0 pb-0">
            {{ $t("components.plancreationwizard.alternative_combination") }}
            <DualListBox
              :source="unselectedCandidateFields"
              :destination="internalCandidateIdentifiers"
              label="Label"
              @onChangeList="onChangeList"
            />
          </v-col>
        </v-layout>
      </v-form>
    </v-card-text>
  </material-card>
</template>
<script>
import AutoSelect from "@/components/AutoSelect";
import { mapActions, mapGetters } from "vuex";
import DualListBox from "dual-listbox-vue";
import "dual-listbox-vue/dist/dual-listbox.css";

export default {
  components: { AutoSelect, DualListBox },
  props: [
    "primaryIdentifier",
    "candidateIdentifiers",
    "includeContributionAmount",
    "selectedFields",
    "disabled",
  ],
  data() {
    return {
      internalPrimaryIdentifier: null,
      valid: false,
      loading: false,
      allCandidateFields: [],
      unselectedCandidateFields: [],
      internalCandidateIdentifiers: [],
      primaryFields: [],
      allPrimaryFields: [],
      internalIncludeContributionAmount: false,
    };
  },
  watch: {
    valid: {
      handler(v) {
        this.$emit("valid", v);
      },
    },
    primaryIdentifier: {
      handler(v) {
        this.internalPrimaryIdentifier = v;
      },
    },
    candidateIdentifiers: {
      handler(v) {
        this.internalCandidateIdentifiers = v;
        this.loadCandidateIdentifiers(v);
      },
    },
    internalPrimaryIdentifier: {
      handler(v) {
        this.$emit("update-primary-identifier", v);
        this.unselectedCandidateFields = this.allCandidateFields.filter(
          (o) =>
            this.internalCandidateIdentifiers.filter((d) => d.Key === o.Key)
              .length === 0 && o.Key !== v.Key
        );
      },
    },
    includeContributionAmount: {
      handler(v) {
        this.internalIncludeContributionAmount = v;
      },
    },
    internalIncludeContributionAmount: {
      handler(v) {
        this.$emit("update-include-contribution-amount", v);
      },
    },
    selectedFields: {
      handler() {
        this.reloadFields();
      },
    },
  },
  async mounted() {
    if (this.selectedFields !== null && this.selectedFields !== undefined) {
      await this.loadFields();
      if (this.primaryIdentifier) {
        this.internalPrimaryIdentifier = this.primaryIdentifier;
      }
      if (this.includeContributionAmount) {
        this.internalIncludeContributionAmount = this.includeContributionAmount;
      }
      this.loadCandidateIdentifiers(this.candidateIdentifiers)
    }
  },
  methods: {
    ...mapActions("plansMembers", ["getHourImportMemberIdentifiers"]),
    loadCandidateIdentifiers(candidateIdentifiers) {
      if (candidateIdentifiers) {
        this.internalCandidateIdentifiers = this.candidateIdentifiers;
        this.unselectedCandidateFields = this.allCandidateFields.filter(
          (o) =>
            this.internalCandidateIdentifiers.filter((d) => d.Key === o.Key)
              .length === 0 &&
            ((this.primaryIdentifier !== null &&
              this.primaryIdentifier !== undefined &&
              this.primaryIdentifier.Key !== o.Key) ||
              this.primaryIdentifier === null ||
              this.primaryIdentifier === undefined)
        );
        this.primaryFields = this.allPrimaryFields.filter(
          (o) =>
            this.internalCandidateIdentifiers.filter((d) => d.Key === o.Key)
              .length === 0
        );
      } else {
        this.unselectedCandidateFields = this.allCandidateFields.filter(
          (o) =>
            (this.primaryIdentifier !== null &&
              this.primaryIdentifier !== undefined &&
              this.primaryIdentifier.Key !== o.Key) ||
            this.primaryIdentifier === null ||
            this.primaryIdentifier === undefined
        );
        this.primaryFields = this.allPrimaryFields.filter(() => true);
      }
    },
    onChangeList: function({ source, destination }) {
      this.unselectedCandidateFields = source;
      this.internalCandidateIdentifiers = destination;
      this.$emit(
        "update-candidate-identifiers",
        this.internalCandidateIdentifiers
      );
      this.primaryFields = this.allPrimaryFields.filter(
        (o) =>
          this.internalCandidateIdentifiers.filter((d) => d.Key === o.Key)
            .length === 0
      );
    },
    async loadFields() {
      this.loading = true;
      try {
        this.allCandidateFields = (await this.getHourImportMemberIdentifiers({
          Type: "candidate",
          Fields: this.selectedFields.map((o) => o.Key),
        })).data;
        this.allPrimaryFields = (await this.getHourImportMemberIdentifiers({
          Type: "primary",
          Fields: this.selectedFields.map((o) => o.Key),
        })).data;
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    async reloadFields() {
      await this.loadFields();

      this.internalCandidateIdentifiers = this.allCandidateFields.filter(
        (o) =>
          this.internalCandidateIdentifiers.filter((d) => d.Key === o.Key)
            .length > 0
      );

      this.primaryFields = this.allPrimaryFields.filter(
        (o) =>
          this.internalCandidateIdentifiers.filter((d) => d.Key === o.Key)
            .length === 0
      );
      if (this.internalPrimaryIdentifier) {
        if (
          this.primaryFields.filter(
            (o) => o.Key === this.internalPrimaryIdentifier.Key
          ).length === 0
        ) {
          this.internalPrimaryIdentifier = null;
        }
      }

      this.unselectedCandidateFields = this.allCandidateFields.filter(
        (o) =>
          this.internalCandidateIdentifiers.filter((d) => d.Key === o.Key)
            .length === 0 &&
          ((this.internalPrimaryIdentifier !== null &&
            this.internalPrimaryIdentifier !== undefined &&
            this.internalPrimaryIdentifier.Key !== o.Key) ||
            this.internalPrimaryIdentifier === null ||
            this.internalPrimaryIdentifier === undefined)
      );
    },
  },
};
</script>
